import ArrowDownSvgComponent from "@assets/svg-components/arrow-down";
import CloseSmallSvgComponent from "@assets/svg-components/close-small";
import ClockSvgComponent from "@assets/svg-components/trips/clock";
import DateSvgComponent from "@assets/svg-components/trips/date";
import HotelSvgComponent from "@assets/svg-components/trips/hotel";
import {
  formHandleBooleanArrayChangeByKey,
  formHandleDateArrayChangeByKey,
  formHandleSelectArrayChangeByKey,
  formHandleSelectArrayChangeByKeyValue,
  formHandleTextArrayChangeByKey,
  formHandleTimeArrayChangeByKey,
} from "@common/handleChange";
import { getValue } from "@utils/lodash";
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import HotelCityPopup from "../../Dropdown/hotel-city-popup";
import InputField from "@common/InputRuleFeild";
import { convertElementaryArrayToJSONArray } from "@common/text-helpers";
import SingleSelectSearchDropdown from "@components/common/CustomSearchableDropdown/SingleSelectSearchDropdown";
import { todayDate } from "@common/date-helpers";
import LocationSvgComponent from "@assets/svg-components/trips/location";
import TripDateComponent from "../common/trip_date";
import TripTimeComponent from "../common/trip_time";
import TripCityComponent from "../common/trip_city";
import AddSvgComponent from "@assets/svg-components/add";
import { toast } from "react-toastify";
import { listManagementByGroupName } from "@services/list-management.service";

function TripCreateCarSection(props: any) {
  const [carTypes, setCarTypes] = useState<any[]>([]);
  const [isLoadingCarTypes, setIsLoadingCarTypes] = useState(true);

  // Default car types
  const defaultCarTypes = convertElementaryArrayToJSONArray([
    "small",
    "medium",
    "large",
    "estate",
    "premium",
    "people_carrier",
    "suv",
  ]);

  useEffect(() => {
    fetchCarTypes();
  }, []);

  const fetchCarTypes = async () => {
    try {
      setIsLoadingCarTypes(true);
      let resp = await listManagementByGroupName("Car Type");
      
      if (resp && getValue(resp, `data.listItems.length`, 0) > 0) {
        // Map API response to dropdown format
        let data = getValue(resp, `data.listItems`, []).map((item: object) => ({
          ...item,
          id: getValue(item, `id`, ""),
          value: getValue(item, `id`, ""),
          label: getValue(item, `text`, ""),
        }));
        setCarTypes(data);
      } else {
        // Use default car types if API returns no data
        setCarTypes(defaultCarTypes);
      }
    } catch (error) {
      console.error("Error fetching car types:", error);
      // Use default car types on error
      setCarTypes(defaultCarTypes);
    } finally {
      setIsLoadingCarTypes(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Car CRUD Section                             */
  /* -------------------------------------------------------------------------- */
  const addSection = () => {
    let obj = {
      pick_up_city_name: "",
      pick_up_location: "",
      departure_location: "",
      pick_up_date: "",
      pick_up_time: "",
      drop_off_location: "",
      arrival_location: "",
      drop_off_date: "",
      drop_off_time: "",
      drop_off_city_name: "",
      car_type: "",
      car_type_others: "",
      is_driver_needed: true,
    };
    props.itenaries.push(obj);
    props.setItenaries([...props.itenaries]);
  };
  const removeSection = (index: number) => {
    let filtered =
      getValue(props, `itenaries.length`, 0) > 0
        ? getValue(props, `itenaries`, []).filter(
            (item: object, i: number) => index !== i
          )
        : [];
    props.setItenaries(filtered);
    props.hideValidation();
  };
  
  /* -------------------------------------------------------------------------- */
  /*                            Date Picker Section                             */
  /* -------------------------------------------------------------------------- */

  return (
    <div className="trips-car-tab-main-container">
      {/* <div className="trips_header_bg d-flex align-items-center p-2 px-4 mt-4">
        <h6 className="header_text__18 ">Car Rentals</h6>
      </div> */}
      <div className="mt-4">
        {getValue(props, `itenaries.length`, 0) > 0 ? (
          getValue(props, `itenaries`, []).map(
            (item: object, index: number) => {
              const selectedCarType = carTypes.find(ct => ct.value === getValue(item, `car_type`, ""));
              const isOtherSelected = selectedCarType?.label?.toLowerCase() === "other";
              
              return (
                <div className="multiple-dyno-wrap">
                  <div className="d-flex justify-content-sm-between align-items-center w-100">
                    <div className="w-100">
                      <div className="d-flex flex-wrap_wrap w-100">
                        <div className="trip_car_container mr-8">
                          <div className="d-flex">
                            <div className="mr-8 trips-car-datepicker">
                              <TripDateComponent
                                validator={props.validator}
                                item={item}
                                index={index}
                                date_key={"pick_up_date"}
                                setItenaries={props.setItenaries}
                                label={"Pick Up Date"}
                                null_date={"drop_off_date"}
                              />
                            </div>
                            <div className="">
                              <TripTimeComponent
                                label={"Pick Up time"}
                                validator={props.validator}
                                item={item}
                                index={index}
                                time_key={"pick_up_time"}
                                setItenaries={props.setItenaries}
                              />
                            </div>
                          </div>
                          <div className="tripcity-with-no-margin-right position-relative">
                            <TripCityComponent
                              item={item}
                              index={index}
                              validator={props.validator}
                              setItenaries={props.setItenaries}
                              label={"Pickup Location"}
                              city_key={"pick_up_location"}
                              city_name_key={"pick_up_city_name"}
                              width={"434px"}
                              locationIcon
                            />
                          </div>
                          {getValue(item, `pick_up_location`, "") && (
                            <div className="tripcity-with-no-margin-right position-relative mt-3">
                              <InputField
                                inputType="TEXT"
                                label="Location"
                                placeholder="Enter pickup location details"
                                name="departure_location"
                                value={getValue(item, `departure_location`, "")}
                                onChange={(e: any) =>
                                  formHandleTextArrayChangeByKey(
                                    index,
                                    e,
                                    props.setItenaries
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                        <div className="trip_car_container ml-8">
                          <div className="d-flex">
                            <div className="trips-car-datepicker mr-8">
                              <TripDateComponent
                                validator={props.validator}
                                item={item}
                                index={index}
                                date_key={"drop_off_date"}
                                setItenaries={props.setItenaries}
                                label={"Drop Off Date"}
                                minDate={
                                  getValue(item, `pick_up_date`, "")
                                    ? new Date(
                                        getValue(item, `pick_up_date`, "")
                                      )
                                    : null
                                }
                              />
                            </div>
                            <div>
                              <TripTimeComponent
                                label={"Drop Off Time"}
                                validator={props.validator}
                                item={item}
                                index={index}
                                time_key={"drop_off_time"}
                                setItenaries={props.setItenaries}
                              />
                            </div>
                          </div>
                          <div className="tripcity-with-no-margin-right position-relative">
                            <TripCityComponent
                              item={item}
                              index={index}
                              validator={props.validator}
                              setItenaries={props.setItenaries}
                              label={"Drop Location"}
                              city_key={"drop_off_location"}
                              city_name_key={"drop_off_city_name"}
                              width={"434px"}
                              locationIcon
                            />
                          </div>
                          {getValue(item, `drop_off_location`, "") && (
                            <div className="tripcity-with-no-margin-right position-relative mt-3">
                              <InputField
                                inputType="TEXT"
                                label="Location"
                                placeholder="Enter drop-off location details"
                                name="arrival_location"
                                value={getValue(item, `arrival_location`, "")}
                                onChange={(e: any) =>
                                  formHandleTextArrayChangeByKey(
                                    index,
                                    e,
                                    props.setItenaries
                                  )
                                }
                              />
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="d-flex align-items-center mb-16">
                        <div className="choose-car-type-wrapper">
                          <div className="d-flex">
                            <label className="trip-label ms-0">
                              {"Car Type"}
                            </label>
                            <span className="form-label-error_red">*</span>
                          </div>
                          <SingleSelectSearchDropdown
                            label={"label"}
                            selectKey={"value"}
                            name="car_type"
                            value={getValue(item, `car_type`, "")}
                            onChange={(e: any) =>
                              formHandleSelectArrayChangeByKey(
                                index,
                                e,
                                "car_type",
                                props.setItenaries
                              )
                            }
                            placeholder={"Choose Car Type"}
                            data={carTypes}
                            width={"284px"}
                            validator={props.validator}
                          />
                        </div>

                        <div className="driver-required-wrap">
                          <div className="d-flex">
                            <label className="trip-label ms-2">&nbsp;</label>
                          </div>

                          <label
                            className="m-0 position-relative"
                            htmlFor={`header-checkbox-cardriver_${index}`}
                          >
                            <input
                              type="checkbox"
                              className="default-checkbox"
                              id={`header-checkbox-cardriver_${index}`}
                              onChange={() =>
                                formHandleBooleanArrayChangeByKey(
                                  index,
                                  "is_driver_needed",
                                  !getValue(item, `is_driver_needed`, false),
                                  props.setItenaries
                                )
                              }
                              checked={getValue(
                                item,
                                `is_driver_needed`,
                                false
                              )}
                            />
                            <div className="custom-checkbox">
                              <img
                                src="/images/uploaded-details/tick.svg"
                                className="img-fluid uploaded-tick"
                              />
                            </div>
                          </label>
                          <label
                            className="ms-3 small_text__16 cursor-pointer"
                            htmlFor={`header-checkbox-cardriver_${index}`}
                          >
                            Driver Required
                          </label>
                        </div>
                      </div>
                      {(isOtherSelected || getValue(item, `car_type_others`, "")) &&(
                        <div className="mb-16" style={{ width: "284px" }}>
                          <InputField
                            inputType="TEXT"
                            label="Car Type"
                            placeholder="Enter car type"
                            name="car_type_others"
                            value={getValue(item, `car_type_others`, "")}
                            onChange={(e: any) =>
                              formHandleTextArrayChangeByKey(
                                index,
                                e,
                                props.setItenaries
                              )
                            }
                            validator={props.validator}
                          />
                        </div>
                      )}
                      <div className="flight_description_wrap mb-16">
                        <InputField
                          inputType="TEXTAREA"
                          placeholder="Special request / Client location / Preferred hotel (Max 200 Characters)"
                          rows={2}
                          name="description"
                          value={getValue(item, `description`, "")}
                          // onChange={(e: any) =>
                          //   formHandleTextArrayChangeByKey(
                          //     index,
                          //     e,
                          //     props.setItenaries
                          //   )
                          // }
                          onChange={(e: any) => {
                            const { value } = e.target;
                            if (value.length <= 200) {
                              formHandleTextArrayChangeByKey(
                                index,
                                e,
                                props.setItenaries
                              );
                            } else {
                              toast.error("Character Limit should be 200");
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className=" mt-2" onClick={() => removeSection(index)}>
                      <CloseSmallSvgComponent />
                    </div>
                  </div>
                </div>
              );
            }
          )
        ) : (
          <div className="mt-5 padd-0-8">
            <div className="trips_header_bg d-flex align-items-center p-2 px-4 mt-4">
              <h6 className="header_text__18 ">Car Rentals</h6>
            </div>
            <p className="text-center mt-3 small_text__14">
              No Cars have been included. Kindly select the option below to add
              them.
            </p>
            <div
              className="d-flex justify-content-center align-items-center cursor-pointer  mt-3"
              onClick={addSection}
            >
              <div className="border border-radius__5 d-flex justify-content-center p-2 px-3">
                <AddSvgComponent size={28} color={"#408dfb"} />
                <h6 className="header_text__18 ms-2 color_primary">Add Cars</h6>
              </div>
            </div>
          </div>
        )}
      </div>

      {getValue(props, `itenaries.length`, 0) > 0 && (
        <div
          className="custom_field_button_container mt-3"
          onClick={addSection}
        >
          <img
            className="custom_field_button_container_image"
            src={`/images/add_circle.svg`}
          />
          <h6 className="header_text__16 color_primary ms-2">
            {getValue(props, `itenaries.length`, 0) > 0 && "Add another car"}
          </h6>
        </div>
      )}
    </div>
  );
}

export default TripCreateCarSection;